import React from 'react';
import { Section, Title } from './Styled';
import { theme } from '../theme';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const HowItWorks: React.FC = () => {
  const { language } = useLanguage();
  const t = translations.howItWorks[language];

  return (
    <Section id="how-it-works" bg={theme.colors.blackBg}>
      <Title style={{ color: theme.colors.green }}>{t.title}</Title>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1.5rem', marginTop: '1rem' }}>
        {t.steps.map((step, idx) => (
          <div
            key={idx}
            style={{
              flex: '1 1 220px',
              minWidth: '220px',
              maxWidth: '280px',
              background: theme.colors.gray,
              border: `1px solid ${theme.colors.border}`,
              borderRadius: 10,
              padding: '1.5rem',
              boxShadow: '0 2px 12px rgba(24,26,27,0.16)',
            }}
          >
            <div style={{
              color: theme.colors.green,
              fontSize: '2rem',
              fontWeight: 700,
              marginBottom: '0.75rem',
              fontFamily: theme.font.heading,
              letterSpacing: '-1px',
            }}>
              {step.number}
            </div>
            <div style={{ color: theme.colors.white, fontWeight: 600, fontSize: '1.05rem', marginBottom: '0.5rem' }}>
              {step.title}
            </div>
            <div style={{ color: '#B7B7B7', fontSize: '0.97rem', lineHeight: 1.65 }}>
              {step.desc}
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
};

export default HowItWorks;
